import React from "react";
import LegalLayout from "./_LegalLayout";

const H = ({ children }) => (
  <h2 className="font-display text-xl sm:text-2xl font-semibold text-ink-900 tracking-tight mt-8">
    {children}
  </h2>
);

const openSettings = () => {
  window.dispatchEvent(new CustomEvent("allinstra:open-cookie-settings"));
};

const CookiePolicy = () => (
  <LegalLayout
    testId="page-cookie-policy"
    overline="Legal · Cookie Policy"
    title="Cookie Policy"
    lead="How Allinstra uses cookies and similar technologies on its website."
  >
    <p className="text-sm text-ink-500">Effective date: 16 April 2026 · Last updated: 16 April 2026</p>

    <H>1. What cookies are</H>
    <p>
      Cookies are small text files stored on your device by websites you visit. They help
      websites function, remember preferences, measure usage, and improve user experience.
    </p>

    <H>2. Types of cookies we may use</H>
    <p>
      <strong>Strictly necessary cookies:</strong> used to operate core site functions, security
      controls, and essential form or session behavior.
    </p>
    <p>
      <strong>Analytics cookies:</strong> used to understand how visitors interact with the site
      and how the site can be improved.
    </p>
    <p>
      <strong>Preference cookies:</strong> used to remember settings such as language or consent
      choices.
    </p>
    <p>
      <strong>Marketing cookies:</strong> used only where such tools are actually enabled and
      only where consent is obtained if required.
    </p>

    <H>3. Legal basis</H>
    <p>
      Strictly necessary cookies may be used on the basis of legitimate interests in running
      the website. Non-essential cookies should only be activated in line with the visitor’s
      consent preferences where applicable law requires that.
    </p>

    <H>4. How to manage cookies</H>
    <p>
      Visitors should be able to accept all cookies, reject non-essential cookies, or manage
      preferences through the cookie banner and preference center. Visitors may also manage
      cookies through their browser settings.
    </p>
    <p>
      <button
        type="button"
        onClick={openSettings}
        data-testid="open-cookie-settings"
        className="btn-secondary"
      >
        Open cookie settings
      </button>
    </p>

    <H>5. Third-party technologies</H>
    <p>
      Some cookies may be set by analytics tools, embedded content providers, form tools, chat
      tools, map tools, or other service providers used on the website.
    </p>

    <H>6. Updates</H>
    <p>
      This Cookie Policy may be updated from time to time to reflect changes in law,
      technology, or site functionality.
    </p>

    <H>7. Contact</H>
    <p>
      For questions about cookies or consent preferences, contact:{" "}
      <a href="mailto:info@allinstra.com" className="underline">info@allinstra.com</a>
    </p>
  </LegalLayout>
);

export default CookiePolicy;
